import {
  LayoutDashboard,
  Package,
  Tag,
  Users,
  History,
  LogOut,
  ChevronLeft,
  Plus,
  Search,
  Edit,
  Eye,
  EyeOff,
  Image,
  Star,
  Trash2,
  Book,
  RefreshCw,
} from "lucide-react";

export const Icons = {
  Dashboard: LayoutDashboard,
  Package: Package,
  Tag: Tag,
  Users: Users,
  History: History,
  LogOut: LogOut,
  ChevronLeft: ChevronLeft,
  Plus: Plus,
  Search: Search,
  Edit: Edit,
  Eye: Eye,
  EyeOff: EyeOff,
  Image: Image,
  Star: Star,
  Trash: Trash2,
  Book: Book,
  RefreshCw: RefreshCw,
};
